import * as constants from './constants'

export const initOnDemandParking = () => ({
    type: constants.INIT_ON_DEMAND_PARKING,
})

export const setOnDemandParkingBaseline = ({ enabled, selectedVehicleIds, selectedCardId }) => ({
    type: constants.SET_ON_DEMAND_PARKING_BASELINE,
    enabled,
    selectedVehicleIds,
    selectedCardId,
})

export const toggleOnDemandVehicle = vehicleId => ({
    type: constants.TOGGLE_ON_DEMAND_VEHICLE,
    vehicleId,
})

export const setOnDemandCard = cardId => ({
    type: constants.SET_ON_DEMAND_CARD,
    cardId,
})

export const setOnDemandEnabled = enabled => ({
    type: constants.SET_ON_DEMAND_ENABLED,
    enabled,
})

export const activateOnDemandRequest = () => ({
    type: constants.ACTIVATE_ON_DEMAND_REQUEST,
})

export const saveOnDemandChangesRequest = () => ({
    type: constants.SAVE_ON_DEMAND_CHANGES_REQUEST,
})
